// src/hooks/pricingUnits/useDeleteAllPricingUnits.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllPricingUnits } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";

const useDeleteAllPricingUnits = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllPricingUnitsMutation,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteAllPricingUnits,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete pricing units");
        },
    });

    return {
        deleteAllPricingUnits: deleteAllPricingUnitsMutation,
        isPending: isPending || isLoading,
    };
};

export default useDeleteAllPricingUnits;
